import { defineStore } from 'pinia'
import {
  THEME_STORAGE_KEY,
  applyResolvedTheme,
  readStoredTheme,
  resolveTheme,
  type ResolvedTheme,
  type ThemeMode,
} from '@/services/themeService.js'

let mediaQuery: MediaQueryList | undefined
let mediaListener: ((event: MediaQueryListEvent) => void) | undefined

export const useThemeStore = defineStore('theme', {
  state: (): { mode: ThemeMode; resolved: ResolvedTheme; initialized: boolean } => ({
    mode: 'system',
    resolved: 'light',
    initialized: false,
  }),
  actions: {
    initialize(): void {
      if (this.initialized || typeof window === 'undefined') return
      mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      this.mode = readStoredTheme(window.localStorage)
      this.resolved = resolveTheme(this.mode, mediaQuery.matches)
      applyResolvedTheme(this.resolved, document.documentElement)
      mediaListener = (event) => {
        if (this.mode !== 'system') return
        this.resolved = resolveTheme('system', event.matches)
        applyResolvedTheme(this.resolved, document.documentElement)
      }
      mediaQuery.addEventListener('change', mediaListener)
      this.initialized = true
    },
    setMode(mode: ThemeMode): void {
      this.mode = mode
      const prefersDark = mediaQuery?.matches ?? false
      this.resolved = resolveTheme(mode, prefersDark)
      if (typeof window !== 'undefined') window.localStorage.setItem(THEME_STORAGE_KEY, mode)
      if (typeof document !== 'undefined') {
        applyResolvedTheme(this.resolved, document.documentElement)
      }
    },
    dispose(): void {
      if (mediaQuery && mediaListener) mediaQuery.removeEventListener('change', mediaListener)
      mediaQuery = undefined
      mediaListener = undefined
      this.initialized = false
    },
  },
})
